<template>
  <div id="app">
    <div class="nav" v-if="hasNav">
      <div class="logo"></div>
      <ul>
        <li>
          <div
            class="main-menu add"
            v-if="addSomething"
            @click="onAddSomethingClick"
          >
            <svg
              data-v-281ea4d1=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <line data-v-281ea4d1="" x1="12" y1="5" x2="12" y2="19"></line>
              <line data-v-281ea4d1="" x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            {{ addSomething }}
          </div>
        </li>
        <li>
          <div
            class="main-menu"
            :class="{ active: $store.state.selectedMainMenu == 'dashboard' }"
            @click="goDashboard"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                class="st0"
                d="M12,3h7c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2h-7 M12,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7 M12,3v18 M21,12 h-9"
              /></svg
            >Dashboard
          </div>
        </li>
        <li :style="updateRoomAndConnectionBtns()">
          <div
            class="main-menu"
            :class="{ active: $store.state.selectedMainMenu == 'rooms' }"
            @click="goRooms"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path
                d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
              ></path></svg
            >My Rooms
          </div>
          <ul class="sub-menu-list">
            <li>
              <div
                class="sub-menu"
                :class="{
                  active: $store.state.selectedSubMenu == 'roomReceived'
                }"
                @click="goRoomReceived"
              >
                Invite Received
              </div>
            </li>
            <li>
              <div
                class="sub-menu"
                :class="{ active: $store.state.selectedSubMenu == 'roomSent' }"
                @click="goRoomSent"
              >
                Invite Sent
              </div>
            </li>
          </ul>
        </li>
        <li :style="updateRoomAndConnectionBtns()">
          <div
            class="main-menu"
            :class="{ active: $store.state.selectedMainMenu == 'connections' }"
            @click="goConnected"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg
            >My People
          </div>
          <ul class="sub-menu-list">
            <li>
              <div
                class="sub-menu"
                :class="{ active: $store.state.selectedSubMenu == 'received' }"
                @click="goReceived"
              >
                Invite Received
              </div>
            </li>
            <li>
              <div
                class="sub-menu"
                :class="{ active: $store.state.selectedSubMenu == 'sent' }"
                @click="goSent"
              >
                Invite Sent
              </div>
            </li>
          </ul>
        </li>
        <li>
          <div
            class="main-menu"
            :class="{ active: $store.state.selectedMainMenu == 'more' }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="1"></circle>
              <circle cx="19" cy="12" r="1"></circle>
              <circle cx="5" cy="12" r="1"></circle></svg
            >More
          </div>
          <ul class="sub-menu-list">
            <li v-if="isAvailableAccessRoomAndConn">
              <div
                class="sub-menu"
                :class="{
                  active: $store.state.selectedSubMenu == 'notifications'
                }"
                @click="goNotifications"
              >
                Notifications
              </div>
            </li>
            <li v-if="isAvailableAccessRoomAndConn">
              <div
                class="sub-menu"
                :class="{ active: $store.state.selectedSubMenu == 'payment' }"
                @click="goPayment"
              >
                My Reports
              </div>
            </li>
            <li>
              <div
                class="sub-menu"
                :class="{ active: $store.state.selectedSubMenu == 'terms' }"
                @click="goTerms"
              >
                Terms of Use
              </div>
            </li>
            <li>
              <a class="sub-menu" :href="'mailto:' + mscMail">Support</a>
            </li>
            <li @click="onLogoutClick">
              <div class="sub-menu">Sign Out</div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="layout">
      <comp-header
        v-if="hasHeader"
        :headerTitle="pageTitle"
        :btnBack="headerBack && isMobile"
        :btnClose="headerClose"
        :btnMenu="headerMenu"
        :btnEdit="headerEdit"
        :btnShare="headerShare"
        @share-click="shareDialog = true"
      />

      <router-view @click.native="settingEditProfile = false" />

      <comp-bottom-tab v-if="hasBottomTab" />

      <div id="more" class="menu" v-if="settingEditProfile">
        <ul>
          <li @click="goNotifications" v-if="isAvailableAccessRoomAndConn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            Notifications
            <!-- <span class="new"></span> -->
          </li>
          <li @click="goPayment" v-if="isAvailableAccessRoomAndConn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path
                d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
              ></path>
            </svg>
            My Reports
          </li>
          <li @click="goTerms">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            Terms of Use
          </li>
          <li>
            <a class="sub-menu" :href="'mailto:' + mscMail">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                <path
                  d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
                ></path>
              </svg>
              Support</a
            >
          </li>
          <li @click="onLogoutClick">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Sign out
          </li>
        </ul>
      </div>

      <div class="modal" v-if="dialog">
        <div class="modal-contents">
          <div class="modal-header">{{ dialogTitle }}</div>
          <div class="modal-body">{{ dialogMsg }}</div>
          <div class="modal-footer">
            <div class="button-group" v-if="dialogFunc">
              <div class="button-container">
                <div class="button" @click="hideDialog">Cancel</div>
              </div>
              <div class="button-container">
                <div class="button" @click="onDialogOKClick">
                  <comp-loading v-if="isLoading"></comp-loading>
                  <div v-else>OK</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="button-container">
                <div class="button" @click="hideDialog">OK</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" v-if="shareDialog">
        <div class="modal-contents">
          <div class="modal-header">Share</div>
          <div class="modal-body">
            <div class="modal-share">
              <button
                class="btn-share share-fb"
                @click="onShareClick('facebook')"
              >
                Share via Facebook
              </button>
              <button
                class="btn-share share-ins"
                style="opacity: 0.2"
                @click="onShareClick('instagram')"
              >
                Share via Instagram
              </button>
              <button
                class="btn-share share-tw"
                style="opacity: 0.2"
                @click="onShareClick('twitter')"
              >
                Share via Twitter
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <div class="button" @click="shareDialog = false">Close</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global FB */
/* global gapi */

import CompHeader from './components/CompHeader'
import CompBottomTab from './components/CompBottomTab'
import CompLoading from '@/components/CompLoading'
import common from '@/utils/common'
import ReportService from '@/services/report-service'
import ConnectionService from '@/services/connection-service'
import UserService from '@/services/user-service'

export default {
  name: 'App',
  mixins: [common],
  data() {
    return {
      hasNav: false,
      hasHeader: false,
      headerBack: false,
      headerMenu: false,
      headerEdit: false,
      headerClose: false,
      headerShare: false,

      hasBottomTab: false,

      pageTitle: '',

      addSomething: '',

      modalEditProfile: false,
      settingEditProfile: false,

      mscMail: 'support@sumforteams.com',

      dialog: false,
      dialogTitle: '',
      dialogMsg: '',
      dialogFunc: null,

      shareDialog: false,

      isLoading: false
    }
  },
  components: {
    CompHeader,
    CompBottomTab,
    CompLoading
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })

    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.init({
        client_id:
          '429322307716-otlmaimikidllodj75uq9d92k6dd1228.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin'
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
    isAvailableAccessRoomAndConn() {
      return this.$store.state.auth.isUserPermitAll
    }
  },
  methods: {
    setNav(showNav) {
      this.hasNav = showNav
    },
    setHeader(title) {
      if (title) {
        this.hasHeader = true
        this.pageTitle = title
      } else {
        this.hasHeader = false
      }
      this.headerEdit = false
      this.headerBack = false
      this.headerClose = false
      this.headerMenu = false

      this.addSomething = ''
    },
    setHeaderShare(isEnable) {
      this.headerShare = isEnable
    },
    showDialog(title, message, func) {
      this.dialogTitle = title
      this.dialogMsg = message
      this.dialogFunc = func
      this.dialog = true
    },
    hideDialog() {
      this.isLoading = false

      this.dialogTitle = ''
      this.dialogMsg = ''
      this.dialogFunc = null
      this.dialog = false
    },
    onAddSomethingClick() {
      this.$EventBus.$emit('addSomething')
    },
    async onDialogOKClick() {
      this.isLoading = true

      await this.dialogFunc()
      this.hideDialog()
    },
    onLogoutClick() {
      this.settingEditProfile = false

      this.showDialog('Sign out', 'Are you sure you want to sign out?', () => {
        FB.logout((response) => {
          console.log(response)
        })
        gapi.auth2.getAuthInstance().disconnect()

        // 로그아웃
        this.$store.dispatch('auth/logout')
        this.goReplace('')
      })
    },
    onShareClick(socialType) {
      var shareType = null
      const routePath = this.$route.path
      if (routePath.includes('/report')) {
        shareType = 'report'
      } else if (routePath.includes('/connectionbrief')) {
        shareType = 'connection'
      }
      if (shareType == null) return

      switch (socialType) {
        case 'facebook':
          if (shareType == 'report') {
            ReportService.shareMyReport().then(({ resultCode, resultData }) => {
              if (resultCode === 0 && !this.isEmpty(resultData)) {
                const shareCode = resultData.code
                FB.ui(
                  {
                    method: 'share',
                    href: `${process.env.VUE_APP_API_BASE_URL}/sum/api/report/share/${shareCode}`
                  },
                  (response) => {
                    this.shareDialog = false

                    if (response && response.error_message) {
                      alert(response.error_message)
                    }
                  }
                )
              }
            })
          } else {
            // eslint-disable-next-line no-case-declarations
            const path = this.$route.path
            const connectionSeqId = path.slice(path.lastIndexOf('/') + 1)

            ConnectionService.shareMyConnBrief(connectionSeqId).then(
              ({ resultCode, resultData }) => {
                if (resultCode === 0 && !this.isEmpty(resultData)) {
                  const shareCode = resultData.code
                  FB.ui(
                    {
                      method: 'share',
                      href: `${process.env.VUE_APP_SHARE_CONNECTION_URL}/${shareCode}`
                    },
                    (response) => {
                      this.shareDialog = false

                      if (response && response.error_message) {
                        alert(response.error_message)
                      }
                    }
                  )
                }
              }
            )
          }
          break
        case 'instagram':
          return
        // break
        case 'twitter':
          return
        // const shareUrl = '123'
        // const shareText = '456'
        // window.open(
        //   `https://twitter.com/share?url=${encodeURIComponent(
        //     shareUrl
        //   )}&text=${encodeURIComponent(shareText)}`,
        //   '',
        //   'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
        // )
      }
    },
    setBottomTab(showBottomTab) {
      this.hasBottomTab = showBottomTab
    },
    getWindowWidth() {
      if (document.documentElement.clientWidth < 720) {
        this.$store.state.isMobile = true
        console.log('under 720')
      } else if (document.documentElement.clientWidth >= 720) {
        this.$store.state.isMobile = false
        console.log('over 720')
      }
    },
    updateRoomAndConnectionBtns() {
      if (this.isAvailableAccessRoomAndConn) {
        return { opacity: 1.0 }
      }
      return { opacity: 0.2 }
    },
    openSetting() {
      if (this.settingEditProfile === true) {
        this.settingEditProfile = false
      } else {
        this.settingEditProfile = true
      }
    },
    goDashboard() {
      this.goPage('dashboard')
    },
    goRooms() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Rooms', { listType: 'roomConnected' })
      } else {
        this.showVerifyDialog()
      }
    },
    goRoomReceived() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Rooms', { listType: 'roomReceived' })
      } else {
        this.showVerifyDialog()
      }
    },
    goRoomSent() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Rooms', { listType: 'roomSent' })
      } else {
        this.showVerifyDialog()
      }
    },
    goConnected() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Connections', { listType: 'connected' })
      } else {
        this.showVerifyDialog()
      }
    },
    goReceived() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Connections', { listType: 'received' })
      } else {
        this.showVerifyDialog()
      }
    },
    goSent() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goPageWithParams('Connections', { listType: 'sent' })
      } else {
        this.showVerifyDialog()
      }
    },
    goMore() {
      if (this.isAvailableAccessRoomAndConn) {
        this.goNotifications()
      } else {
        this.goTerms()
      }
    },
    goNotifications() {
      this.settingEditProfile = false
      this.goPage('notifications')
    },
    goPayment() {
      this.settingEditProfile = false
      this.goPage('payment')
    },
    goTerms() {
      this.settingEditProfile = false
      this.goPageWithParams('TermsConditions', { isShowMenus: true })
    },
    showVerifyDialog() {
      UserService.getMilestone().then((data) => {
        this.isLoading = false

        var isPermitAllow = true
        data.list.forEach((milestone) => {
          if (milestone.milestoneSeqId === 2) {
            if (!milestone.isDone) isPermitAllow = false
          } else if (milestone.milestoneSeqId === 3) {
            if (!milestone.isDone) isPermitAllow = false
          }
        })
        if (data.list.length === 0) isPermitAllow = false
        this.$store.commit('setUserPermitAll', isPermitAllow)

        this.isLoading = false

        if (isPermitAllow) {
          this.showDialog('SUM', 'All features have been unlocked.')
        } else {
          this.showDialog(
            'Wait',
            'Please fill out your profile and verify E-mail.',
            () => {
              this.$EventBus.$emit('editProfile')
            }
          )
        }
      })
    }
  }
}
</script>

<style lang="scss" src="./app.scss"></style>
